import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, unref as _unref, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["action"]
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { value: 0 }
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "color-selection" }
const _hoisted_11 = ["id", "value"]
const _hoisted_12 = ["for", "title", "aria-label"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]

import { ref, computed, onMounted } from 'vue';
import { categories as getCategories } from '@/js/data/category';
import { colors } from '@/js/data/color';
import { materials } from '@/js/data/material';
import IButton from '@/js/components/molecules/IButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ListingMenu',
  props: {
    initialQuery: {},
    initialCategory: {},
    initialSubCategory: {},
    initialFromPrice: {},
    initialToPrice: {},
    initialMaterial: {},
    initialColor: {},
    initialGift: {},
    initialOrdermade: {},
    initialVintage: {},
    initialSelling: {},
    sort: {},
    order: {}
  },
  setup(__props: any) {

const props = __props;
const prices = ['500', '1000', '3000', '5000', '10000', '15000', '20000', '30000', '50000', '100000'];
const q = ref(props.initialQuery);
const fromPrice = ref(props.initialFromPrice);
const toPrice = ref(props.initialToPrice);
const category = ref(0);
const categories = ref<
  {
    categoryId: number;
    slug: string;
    name: string;
  }[]
>(getCategories({ parentCategoryId: 0 }));
const subCategory = ref(0);
const subCategories = ref<
  {
    categoryId: number;
    slug: string;
    name: string;
  }[]
>();
const material = ref(props.initialMaterial);
const color = ref(props.initialColor);
const colorList = [
  ...colors(),
  {
    colorId: 0,
    slug: 'none',
    name: '選択なし',
  },
];
const gift = ref(props.initialGift === '1');
const ordermade = ref(props.initialOrdermade === '1');
const vintage = ref(props.initialVintage === '1');
const toggleSelling = ref(props.initialSelling === '1');
const categorySlug = computed(() => categories.value?.find((cat) => cat.categoryId === category.value)?.slug || '');
const subCategorySlug = computed(() => subCategories.value?.find((subCat) => subCat.categoryId === subCategory.value)?.slug || '');
const actionPath = computed(() => (categorySlug.value || subCategorySlug.value ? `/category${categorySlug.value ? `/${categorySlug.value}` : ''}${subCategorySlug.value ? `/${subCategorySlug.value}` : ''}` : '/listing'));
const selling = computed(() => (toggleSelling.value ? 'on' : 'off'));
const onChangeCategory = () => {
  subCategories.value = getCategories({ parentCategoryId: category.value });
  subCategory.value = 0;
};
const onClickClearButton = () => {
  q.value = '';
  fromPrice.value = '';
  toPrice.value = '';
  material.value = '';
  color.value = '';
  category.value = 0;
  subCategory.value = 0;
  gift.value = false;
  vintage.value = false;
  ordermade.value = false;
  toggleSelling.value = false;
};
const onSubmit = () => {
  if (q.value) {
    window.dataLayer?.push({
      event: 'search',
      search_term: q.value,
    });
  }
};

onMounted(() => {
  const initialCategory = categories.value?.find((cat) => cat.name === props.initialCategory);
  if (initialCategory) {
    category.value = initialCategory.categoryId;
    onChangeCategory();
  }
  const initialSubCategory = subCategories.value?.find((cat) => cat.name === props.initialSubCategory);
  if (initialSubCategory) {
    subCategory.value = initialSubCategory.categoryId;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.menu)
  }, [
    _createElementVNode("form", {
      action: actionPath.value,
      onSubmit: onSubmit
    }, [
      _createElementVNode("input", {
        id: "selling",
        type: "hidden",
        name: "selling",
        value: selling.value
      }, null, 8, _hoisted_2),
      _cache[46] || (_cache[46] = _createTextVNode()),
      _cache[47] || (_cache[47] = _createElementVNode("input", {
        id: "sort",
        type: "hidden",
        name: "sort",
        value: "popular"
      }, null, -1)),
      _cache[48] || (_cache[48] = _createTextVNode()),
      _cache[49] || (_cache[49] = _createElementVNode("input", {
        id: "order",
        type: "hidden",
        name: "order",
        value: "asc"
      }, null, -1)),
      _cache[50] || (_cache[50] = _createTextVNode()),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.$style.section, _ctx.$style.searchWord])
      }, [
        _cache[11] || (_cache[11] = _createElementVNode("h3", null, "キーワード", -1)),
        _cache[12] || (_cache[12] = _createTextVNode()),
        _withDirectives(_createElementVNode("input", {
          id: "q",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((q).value = $event)),
          type: "search",
          name: "q",
          "aria-label": "キーワード"
        }, null, 512), [
          [_vModelText, q.value]
        ])
      ], 2),
      _cache[51] || (_cache[51] = _createTextVNode()),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.section)
      }, [
        _cache[16] || (_cache[16] = _createElementVNode("h3", null, "カテゴリー", -1)),
        _cache[17] || (_cache[17] = _createTextVNode()),
        _withDirectives(_createElementVNode("select", {
          id: "category",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((category).value = $event)),
          name: "category",
          class: "mb-14",
          "aria-label": "カテゴリー",
          onChange: onChangeCategory
        }, [
          _cache[13] || (_cache[13] = _createElementVNode("option", { value: 0 }, "選択してください", -1)),
          _cache[14] || (_cache[14] = _createTextVNode()),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (cat) => {
            return (_openBlock(), _createElementBlock("option", {
              key: cat.categoryId,
              value: cat.categoryId
            }, _toDisplayString(cat.name), 9, _hoisted_3))
          }), 128))
        ], 544), [
          [_vModelSelect, category.value]
        ]),
        _cache[18] || (_cache[18] = _createTextVNode()),
        _withDirectives(_createElementVNode("select", {
          id: "sub_category",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((subCategory).value = $event)),
          disabled: !category.value,
          name: "sub_category",
          "aria-label": "サブカテゴリー"
        }, [
          _createElementVNode("option", _hoisted_5, _toDisplayString(category.value ? '選択してください' : '-'), 1),
          _cache[15] || (_cache[15] = _createTextVNode()),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subCategories.value, (subCat) => {
            return (_openBlock(), _createElementBlock("option", {
              key: subCat.categoryId,
              value: subCat.categoryId
            }, _toDisplayString(subCat.name), 9, _hoisted_6))
          }), 128))
        ], 8, _hoisted_4), [
          [_vModelSelect, subCategory.value]
        ])
      ], 2),
      _cache[52] || (_cache[52] = _createTextVNode()),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.section)
      }, [
        _cache[26] || (_cache[26] = _createElementVNode("h3", null, "価格", -1)),
        _cache[27] || (_cache[27] = _createTextVNode()),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.priceSortWrap)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.priceInputWrap)
          }, [
            _withDirectives(_createElementVNode("select", {
              id: "from_price",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((fromPrice).value = $event)),
              name: "from_price",
              "aria-label": "下限価格"
            }, [
              _cache[19] || (_cache[19] = _createElementVNode("option", { value: "" }, null, -1)),
              _cache[20] || (_cache[20] = _createTextVNode()),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(prices, (price) => {
                return _createElementVNode("option", {
                  key: price,
                  value: price
                }, _toDisplayString(Number(price).toLocaleString()), 9, _hoisted_7)
              }), 64))
            ], 512), [
              [_vModelSelect, fromPrice.value]
            ])
          ], 2),
          _cache[23] || (_cache[23] = _createTextVNode()),
          _cache[24] || (_cache[24] = _createElementVNode("div", null, "〜", -1)),
          _cache[25] || (_cache[25] = _createTextVNode()),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.priceInputWrap)
          }, [
            _withDirectives(_createElementVNode("select", {
              id: "to_price",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((toPrice).value = $event)),
              name: "to_price",
              "aria-label": "上限価格"
            }, [
              _cache[21] || (_cache[21] = _createElementVNode("option", { value: "" }, null, -1)),
              _cache[22] || (_cache[22] = _createTextVNode()),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(prices, (price) => {
                return _createElementVNode("option", {
                  key: price,
                  value: price
                }, _toDisplayString(Number(price).toLocaleString()), 9, _hoisted_8)
              }), 64))
            ], 512), [
              [_vModelSelect, toPrice.value]
            ])
          ], 2)
        ], 2)
      ], 2),
      _cache[53] || (_cache[53] = _createTextVNode()),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.section)
      }, [
        _cache[30] || (_cache[30] = _createElementVNode("h3", null, "素材", -1)),
        _cache[31] || (_cache[31] = _createTextVNode()),
        _withDirectives(_createElementVNode("select", {
          id: "material",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((material).value = $event)),
          name: "material",
          "aria-label": "素材"
        }, [
          _cache[28] || (_cache[28] = _createElementVNode("option", { value: "" }, "すべての素材", -1)),
          _cache[29] || (_cache[29] = _createTextVNode()),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(materials)(), (item) => {
            return (_openBlock(), _createElementBlock("option", {
              key: item.materialId,
              value: item.slug
            }, _toDisplayString(item.name), 9, _hoisted_9))
          }), 128))
        ], 512), [
          [_vModelSelect, material.value]
        ])
      ], 2),
      _cache[54] || (_cache[54] = _createTextVNode()),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.section)
      }, [
        _cache[33] || (_cache[33] = _createElementVNode("h3", null, "色", -1)),
        _cache[34] || (_cache[34] = _createTextVNode()),
        _createElementVNode("ul", _hoisted_10, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(colorList, (item) => {
            return _createElementVNode("li", {
              key: item.colorId
            }, [
              _withDirectives(_createElementVNode("input", {
                id: `color_${item.slug}`,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((color).value = $event)),
                name: "color",
                type: "radio",
                value: item.slug
              }, null, 8, _hoisted_11), [
                [_vModelRadio, color.value]
              ]),
              _cache[32] || (_cache[32] = _createTextVNode()),
              _createElementVNode("label", {
                for: `color_${item.slug}`,
                title: item.name,
                "aria-label": item.name
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(`color-${item.slug}`)
                }, null, 2)
              ], 8, _hoisted_12)
            ])
          }), 64))
        ])
      ], 2),
      _cache[55] || (_cache[55] = _createTextVNode()),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.$style.section, _ctx.$style.checkbox])
      }, [
        _createElementVNode("p", null, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((vintage).value = $event)),
              type: "checkbox",
              name: "vintage"
            }, null, 512), [
              [_vModelCheckbox, vintage.value]
            ]),
            _cache[35] || (_cache[35] = _createTextVNode("アンティーク・ヴィンテージ", -1))
          ])
        ]),
        _cache[39] || (_cache[39] = _createTextVNode()),
        _createElementVNode("p", null, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((gift).value = $event)),
              type: "checkbox",
              name: "gift"
            }, null, 512), [
              [_vModelCheckbox, gift.value]
            ]),
            _cache[36] || (_cache[36] = _createTextVNode("ギフト可", -1))
          ])
        ]),
        _cache[40] || (_cache[40] = _createTextVNode()),
        _createElementVNode("p", null, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((ordermade).value = $event)),
              type: "checkbox",
              name: "ordermade"
            }, null, 512), [
              [_vModelCheckbox, ordermade.value]
            ]),
            _cache[37] || (_cache[37] = _createTextVNode("オーダーメイド可", -1))
          ])
        ]),
        _cache[41] || (_cache[41] = _createTextVNode()),
        _createElementVNode("p", null, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((toggleSelling).value = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, toggleSelling.value]
            ]),
            _cache[38] || (_cache[38] = _createTextVNode("在庫あり", -1))
          ])
        ])
      ], 2),
      _cache[56] || (_cache[56] = _createTextVNode()),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.submit)
      }, [
        _createElementVNode("button", {
          type: "button",
          onClick: onClickClearButton
        }, "クリア"),
        _cache[43] || (_cache[43] = _createTextVNode()),
        _createVNode(IButton, {
          type: "primary",
          "native-type": "submit",
          size: "small"
        }, {
          default: _withCtx(() => _cache[42] || (_cache[42] = [
            _createTextVNode("絞り込む", -1)
          ])),
          _: 1,
          __: [42]
        }),
        _cache[44] || (_cache[44] = _createTextVNode()),
        (_ctx.sort)
          ? (_openBlock(), _createElementBlock("input", {
              key: 0,
              type: "hidden",
              name: "sort",
              value: _ctx.sort
            }, null, 8, _hoisted_13))
          : _createCommentVNode("", true),
        _cache[45] || (_cache[45] = _createTextVNode()),
        (_ctx.order)
          ? (_openBlock(), _createElementBlock("input", {
              key: 1,
              type: "hidden",
              name: "order",
              value: _ctx.order
            }, null, 8, _hoisted_14))
          : _createCommentVNode("", true)
      ], 2)
    ], 40, _hoisted_1)
  ], 2))
}
}

})